import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './BlogPage.css';
import { setPageTitle, pageTitles, pageDescriptions } from '../utils/pageTitle';
import { useLanguage } from '../contexts/LanguageContext';

const BlogPage = () => {
  const { t, localizedPath, language } = useLanguage();

  useEffect(() => {
    setPageTitle(pageTitles.blog, pageDescriptions.blog, 'blog', language);
  }, [language]);

  const articles = [
    {
      key: 'delivery',
      href: '/contact',
      accent: 'delivery'
    },
    {
      key: 'cloud',
      href: '/services#cloud-migration',
      accent: 'cloud'
    },
    {
      key: 'ai',
      href: '/services#ai-solutions',
      accent: 'ai'
    }
  ];

  const editorialItems = t('blog.editorialItems');

  return (
    <div className="blog-page">
      <section className="blog-hero section">
        <div className="container">
          <div className="blog-hero-content">
            <p className="blog-eyebrow">{t('blog.heroEyebrow')}</p>
            <h1 className="page-title">{t('blog.heroTitle')}</h1>
            <p className="blog-hero-description">{t('blog.heroDescription')}</p>
          </div>
        </div>
      </section>

      <section className="blog-featured section">
        <div className="container">
          <h2 className="section-title">{t('blog.featuredTitle')}</h2>
          <div className="blog-grid">
            {articles.map((article) => {
              const entry = t(`blog.featuredArticles.${article.key}`);

              return (
                <article key={article.key} className={`blog-card blog-card-${article.accent}`}>
                  <div className="blog-card-meta">
                    <span className="blog-category">{entry.category}</span>
                    <span className="blog-read-time">{entry.readTime}</span>
                  </div>
                  <h3 className="blog-card-title">{entry.title}</h3>
                  <p className="blog-card-excerpt">{entry.excerpt}</p>
                  <Link to={localizedPath(article.href)} className="blog-card-link">
                    {t('common.readMore')}
                  </Link>
                </article>
              );
            })}
          </div>
        </div>
      </section>

      <section className="blog-editorial section">
        <div className="container">
          <div className="blog-editorial-panel">
            <h2 className="section-title">{t('blog.editorialTitle')}</h2>
            <ul className="blog-editorial-list">
              {Array.isArray(editorialItems) && editorialItems.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      <section className="blog-cta section">
        <div className="container">
          <div className="blog-cta-panel">
            <h2 className="blog-cta-title">{t('blog.ctaTitle')}</h2>
            <p className="blog-cta-description">{t('blog.ctaDescription')}</p>
            <Link to={localizedPath('/contact')} className="btn-primary">
              {t('blog.ctaButton')}
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default BlogPage;
